import { useEffect, useRef, useState } from "react";
import Header from "../header/header";
import { useGame } from "../header/GameContext";
import { CHAT_DATA } from "./chatData";
import "./chat.css";

function ChatBox({ DateVal, titImgClass = "", timerMode = "run", onFinish }) {
  const { startTimer, pauseTimer } = useGame();

  /* =========================
     타이머
  ========================= */
  useEffect(() => {
    timerMode === "run" ? startTimer() : pauseTimer();
  }, [timerMode]);

  /* =========================
     데이터
  ========================= */
  const contents =
    DateVal === "DATA1" ? CHAT_DATA.dataArr01 : CHAT_DATA.dataArr02;

  /* =========================
     상태
  ========================= */
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState([]);
  const [activeButton, setActiveButton] = useState(null);

  const chatBoxRef = useRef(null);

  /* =========================
     공통 스크롤 함수 (🔥 핵심)
  ========================= */
  const scrollToBottom = () => {
    if (!chatBoxRef.current) return;
    chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
  };

  /* =========================
     채팅 출력 로직
  ========================= */
  useEffect(() => {
    if (idx >= contents.length) return;

    const item = contents[idx];

    /* 🔥 scroll 타입 */
    if (item.type === "scroll") {
      setIdx((prev) => prev + 1);

      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 0);
      return;
    }

    /* 🔥 button 타입 */
    if (item.type === "button") {
      setActiveButton(item);
      requestAnimationFrame(scrollToBottom);
      return;
    }

    /* 🔥 일반 채팅 */
    const t = setTimeout(() => {
      setVisible((prev) => [...prev, item]);
      setIdx((prev) => prev + 1);
    }, 800);

    return () => clearTimeout(t);
  }, [idx]);

  /* =========================
     채팅 추가 시 항상 하단 유지
  ========================= */
  useEffect(() => {
    requestAnimationFrame(scrollToBottom);
  }, [visible, activeButton]);

  /* =========================
     버튼 클릭
  ========================= */
  const onBtnClick = () => {
    if (!activeButton) return;

    const { action, route } = activeButton;

    setActiveButton(null);
    setIdx((prev) => prev + 1);

    if (action === "finish") onFinish?.();
    if (action === "route") onFinish?.(route);
  };

  return (
    <div className="box content_box1">
      <Header />

      <div className="box_con con_box1 con_pd5 ans0001">
        <div className={`mission_tit ${titImgClass}`} />

        {/* 채팅 영역 (스크롤 주체) */}
        <div
          className="chat_box2 mt24"
          ref={chatBoxRef}
          style={{ overflowY: "auto", maxHeight: "400px" }}
        >
          {visible.map((c, i) => {
            if (c.type === "chatInfo_Talk1") {
              return (
                <div
                  key={i}
                  className={`chatInfo_Talk ${c.marType || ""}`}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              );
            }

            if (c.type === "leftCharacter") {
              return (
                <div key={i} className={`chat_b_left ${c.marType || ""}`}>
                  <div className="chat_b_l_left mr8">
                    <span className={c.chat_icon} />
                  </div>
                  <div className="chat_b_l_right">
                    <p className="chat_tit mb4">{c.chat_tit}</p>
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                </div>
              );
            }

            if (c.type === "left_txt") {
              return (
                <div key={i} className={`chat_b_left ${c.marType || ""}`}>
                  <div className="chat_b_l_left mr8" />
                  <div className="chat_b_l_right">
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                </div>
              );
            }

            return null;
          })}
        </div>

        {/* 버튼 영역 */}
        {activeButton && (
          <div className="chat_btn_area mt20">
            <button className="inputBtn02" onClick={onBtnClick}>
              {activeButton.label}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatBox;
